import React from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router-dom';

import { useTheme } from '@mui/material/styles';

import withRouter from '../../../hoc/with-router';
import { Paths } from '../../../shared/paths';
import EditTraining from '../edit-training/EditTraining';
import ViewTraining from '../view-training/ViewTraining';
import { useStyles } from './Training.styles';

function Training(props) {
  const { params } = props;
  const { t } = useTranslation();
  const theme = useTheme();
  const { classes } = useStyles(theme);

  return (
    <Routes>
      <Route path={`${Paths.trainings.edit}`} element={<EditTraining />} />
      <Route path={`${Paths.trainings.view}/*`} element={<ViewTraining />} />
    </Routes>
  );
}

export default withRouter(Training);
